"use strict";

module.exports = require("./Bottleneck");